import styles from './FJImageToImageRight.module.less';
import PropTypes from 'prop-types';
import FJDragBox from '../../../common/components/FJDragBox/FJDragBox';
import FJDisplayHeaderContainer from '../../FJMainPreview/FJDisplayHeader/FJDisplayHeaderContainer';
import FJCreationPanelContainer from '../../FJMainPreview/FJCreationPanel/FJCreationPanelContainer';
import FJHistoryPanelContainer from '../../FJMainPreview/FJHistoryPanel/FJHistoryPanelContainer';
import VideoGradientIcon from '../../../assets/svg/video-gradient.svg?react';
import classNames from 'classnames';
import { useMemo } from 'react';
import FJUtil from '../../../util/FJUtil';
import FJConstant from '../../../constants/FJConstant';
import FJButton, { FJButtonType } from '../../../common/components/FJButton/FJButton';
import FJLocalStore from '../../../store/FJLocalStore';
import DownloadIcon from '../../../assets/svg/download-black.svg?react';

const FJImageToImageRight = props => {
    const {
        uploadImg,
        setIsDraggingFile,
        taskStatus,
        headerTabIndex,
        isCanDownload,
        download,
        imageToVideo,
        downloadEditImageLoading,
    } = props;

    const rightChildren = useMemo(() => {
        if (
            FJUtil.isGeneratingStatus(taskStatus) ||
            taskStatus === FJConstant.ERROR ||
            headerTabIndex !== 0 ||
            !isCanDownload
        ) {
            return null;
        }

        if (window.isEditPage) return null;

        return (
            <div className={styles.right_btn_box}>
                <FJButton
                    onClick={imageToVideo}
                    className={classNames(styles.image_to_video_btn)}
                    textClassName={styles.download_text}
                    text={FJLocalStore._('image-to-video')}
                    type={FJButtonType.LIGHT_GRADIENT}
                    icon={<VideoGradientIcon className={styles.image_to_video_icon} />}
                />

                <FJButton
                    onClick={download}
                    className={classNames(styles.download, downloadEditImageLoading && styles.loading)}
                    textClassName={styles.download_text}
                    text={FJLocalStore._('download')}
                    isLoading={downloadEditImageLoading}
                    type={FJButtonType.GRADIENT}
                    icon={<DownloadIcon className={styles.download_icon} />}
                />
            </div>
        );
    }, [download, imageToVideo, downloadEditImageLoading, taskStatus, headerTabIndex, isCanDownload]);

    return (
        <FJDragBox setIsDragging={setIsDraggingFile} uploadFile={uploadImg} className={classNames(styles.app_right)}>
            <FJDisplayHeaderContainer isShowProgress={false} rightChildren={rightChildren} />

            <FJCreationPanelContainer activeHeaderTabIndex={0} />

            <FJHistoryPanelContainer activeHeaderTabIndex={1} />
        </FJDragBox>
    );
};

FJImageToImageRight.propTypes = {
    uploadImg: PropTypes.func,
    setIsDraggingFile: PropTypes.func,
    taskStatus: PropTypes.string,
    headerTabIndex: PropTypes.number,
    isCanDownload: PropTypes.bool,
    download: PropTypes.func,
    downloadEditImageLoading: PropTypes.bool,
    imageToVideo: PropTypes.func,
};

export default FJImageToImageRight;
